import { GridColDef } from "@mui/x-data-grid";

export const paymentTypeColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
